var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileUploadIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 40,
    viewBox: "0 0 31 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.16667 0C2.31693 0 0 2.24219 0 5V35C0 37.7578 2.31693 40 5.16667 40H25.8333C28.6831 40 31 37.7578 31 35V12.5H20.6667C19.2378 12.5 18.0833 11.3828 18.0833 10V0H5.16667ZM20.6667 0V10H31L20.6667 0ZM17.4375 31.875C17.4375 32.9141 16.5737 33.75 15.5 33.75C14.4263 33.75 13.5625 32.9141 13.5625 31.875V23.8984L11.0599 26.3203C10.301 27.0547 9.07396 27.0547 8.32318 26.3203C7.5724 25.5859 7.56432 24.3984 8.32318 23.6719L14.1357 18.0469C14.8945 17.3125 16.1216 17.3125 16.8724 18.0469L22.6849 23.6719C23.4437 24.4062 23.4437 25.5938 22.6849 26.3203C21.926 27.0469 20.699 27.0547 19.9482 26.3203L17.4456 23.8984V31.875H17.4375Z",
    fill: "#ffffff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/file-upload-icon.9e0bebc2dcdb2f09bdfc3e0980d51d43.svg";
export { ForwardRef as ReactComponent };